import { RefObject, useEffect } from 'react';

/**
 * RSuite Table renders column resize handles and scrollbar thumbs as role="button"
 * without accessible names, and updates them as columns resize. Patch labels whenever
 * the table subtree changes.
 */
export default function useRsuiteTableA11yPatches(
  containerRef: RefObject<HTMLElement | null>,
) {
  useEffect(() => {
    const root = containerRef.current;
    if (!root) {
      return undefined;
    }

    const patch = () => {
      root
        .querySelectorAll('.rs-table-column-resize-spanner')
        .forEach(el => {
          if (!el.getAttribute('aria-label')) {
            el.setAttribute('aria-label', 'Resize column');
          }
        });
      root.querySelectorAll('.rs-table-scrollbar-handle').forEach(el => {
        if (!el.getAttribute('aria-label')) {
          el.setAttribute('aria-label', 'Scroll table');
        }
      });
    };

    patch();
    const observer = new MutationObserver(patch);
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [containerRef]);
}
